import {MSG_GET_INTENT_DESCRIPTION, ROLE_CUSTOMER, ROLE_SYSTEM, TYPE_MESSAGE} from "../utils/constants";

var _intentsHistoryList = [];
var _enableIntentsHistory = false;

export function enableIntentsHistory(val) {
    _enableIntentsHistory = val;
}

export function isIntentsHistoryEnabled() {
    return _enableIntentsHistory;
}

export function clearIntentsHistory() {
    _intentsHistoryList.length = 0;
}

export function addIntentsHistory(intentData, customerData) {
    if (!_enableIntentsHistory) {
        return;
    }
    let parsedIntentData;
    try {
        parsedIntentData = JSON.parse(intentData.Content);
    } catch (e) {
    }
    if (parsedIntentData
        && parsedIntentData.intent
        && parsedIntentData.intent.indexOf('Sys_GetDescription') === -1
    ) {
        _intentsHistoryList.push({
            botData: intentData,
            customerData: customerData || null,
        });
    }
}

export function updateLastIntentHistory(customerData, botData) {
    if (!_enableIntentsHistory) {
        return;
    }
    try {
        if (!_intentsHistoryList.length || !customerData) {
            return;
        }
        let lastHistoryItem = _intentsHistoryList[_intentsHistoryList.length - 1];
        if (customerData.inputText) {
            customerData.inputText = customerData.inputText.replace(/sys_back:\w+:/, "");
        }
        lastHistoryItem.customerData = customerData;
        if (botData) {
            lastHistoryItem.botData = botData;
        }
    } catch (e) {
        console.error(e);
    }
}

export function getBackToIntentHistoryData() {
    if (!_enableIntentsHistory) {
        return;
    }
    try {
        let backToItem;
        let backCustomerData;
        if (_intentsHistoryList.length === 1 && (_intentsHistoryList[0] || {}).customerData) {
            backToItem = _intentsHistoryList[0];
            backCustomerData = null;
        } else {
            if (_intentsHistoryList.length < 2) {
                return null;
            }
            backToItem = _intentsHistoryList[_intentsHistoryList.length - 2];
            backCustomerData = (_intentsHistoryList[_intentsHistoryList.length - 3] || {}).customerData;
        }
        let botParsedData;
        try {
            botParsedData = JSON.parse(backToItem.botData.Content);
        } catch (e) {
        }
        return {
            botData: botParsedData,
            customerData: backCustomerData,
        };
    } catch (e) {
        console.error(e);
    }
}

export function parseBackToIntentHistoryData(historyData) {
    if (!_enableIntentsHistory) {
        return undefined;
    }
    let result;
    try {
        if (!historyData) {
            return null;
        }
        let message;
        let customerInputText = ((historyData || {}).customerData || {}).inputText;
        if (historyData.botData) {
            message = "sys_back:" + historyData.botData.intent + ':' + (customerInputText || "Back");
        } else if (customerInputText) {
            message = customerInputText.replace(/sys_back:\w+:/, "");
        }
        if (message && _intentsHistoryList.length > 1) {
            _intentsHistoryList.length -= 2;
        }
        result = {
            message: message,
            inputText: customerInputText,
        };
    } catch (e) {
        console.error(e);
    }
    return result;
}

export function getBackToIntentHistoryMessage() {
    if (!_enableIntentsHistory) {
        return undefined;
    }
    try {
        const lastData = getBackToIntentHistoryData();
        const lastDataParsed = parseBackToIntentHistoryData(lastData);
        return (lastDataParsed || {}).message;
    } catch (e) {
        console.error(e);
    }
}

export function restoreIntentsHistory(messages) {
    if (!_enableIntentsHistory) {
        return undefined;
    }
    if (messages && messages.length) {
        messages.map((data, key, arr) => {
            if (data.ParticipantRole === ROLE_SYSTEM && data.Type === TYPE_MESSAGE) {
                let customerData = null;
                for (let i = key + 1; i < arr.length; i++) {
                    if (arr[i].ParticipantRole === ROLE_CUSTOMER
                        && arr[i].Type === TYPE_MESSAGE
                        && data.Content.indexOf(MSG_GET_INTENT_DESCRIPTION) === -1
                    ) {
                        customerData = {
                            inputText: (arr[i] || {}).Content
                        };
                        break;
                    }
                }
                addIntentsHistory(data, customerData);
            }
        });
    }
}
